import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";

import Tooltip from '@material-ui/core/Tooltip';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";

// core components

import buttonStyle from "./button-style";

function RegularButton({ ...props }) {
    const {
        classes,
        color,
        round,
        children,
        fullWidth,
        disabled,
        simple,
        size,
        block,
        link,
        justIcon,
        className,
        tooltipTitle,
        ...rest
    } = props;
    const btnClasses = classNames({
        [classes.button]: true,
        [classes[size]]: size,
        [classes[color]]: color,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled,
        [classes.simple]: simple,
        [classes.block]: block,
        [classes.link]: link,
        [classes.justIcon]: justIcon,
        [className]: className
    });
    let title = tooltipTitle ? tooltipTitle : " ";
    let titleNotFound = tooltipTitle === "" || tooltipTitle === undefined || tooltipTitle === null;
    return (
        <Tooltip arrow disableFocusListener={titleNotFound} disableHoverListener={titleNotFound} title={title}>
            <Button {...rest} className={btnClasses}>
                {children}
            </Button>
        </Tooltip>
    );
}

RegularButton.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "rose",
        "white",
        "facebook",
        "twitter",
        "google",
        "github",
        "transparent",
        "blue",
        "red",
        "green"
    ]),
    size: PropTypes.oneOf(["sm", "lg", ""]),
    simple: PropTypes.bool,
    round: PropTypes.bool,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    link: PropTypes.bool,
    justIcon: PropTypes.bool,
    tooltipTitle: PropTypes.string
};

export default withStyles(buttonStyle)(RegularButton);
